/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class EnergyPlotApi extends runtime.BaseAPI {
    /**
     * Create Energy Plot
     */
    async v2CreateEnergyPlotRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2CreateEnergyPlot().');
        }
        if (requestParameters['energyPlotCreate'] == null) {
            throw new runtime.RequiredError('energyPlotCreate', 'Required parameter "energyPlotCreate" was null or undefined when calling v2CreateEnergyPlot().');
        }
        const queryParameters = {};
        if (requestParameters['tabId'] != null) {
            queryParameters['tab_id'] = requestParameters['tabId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/energy-plot/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['energyPlotCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Energy Plot
     */
    async v2CreateEnergyPlot(requestParameters, initOverrides) {
        const response = await this.v2CreateEnergyPlotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Energy Plot
     */
    async v2DeleteEnergyPlotRaw(requestParameters, initOverrides) {
        if (requestParameters['energyPlotId'] == null) {
            throw new runtime.RequiredError('energyPlotId', 'Required parameter "energyPlotId" was null or undefined when calling v2DeleteEnergyPlot().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/energy-plot/{energy_plot_id}`;
        urlPath = urlPath.replace(`{${"energy_plot_id"}}`, encodeURIComponent(String(requestParameters['energyPlotId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Delete Energy Plot
     */
    async v2DeleteEnergyPlot(requestParameters, initOverrides) {
        const response = await this.v2DeleteEnergyPlotRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get Energy Plot
     */
    async v2GetEnergyPlotRaw(requestParameters, initOverrides) {
        if (requestParameters['energyPlotId'] == null) {
            throw new runtime.RequiredError('energyPlotId', 'Required parameter "energyPlotId" was null or undefined when calling v2GetEnergyPlot().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/energy-plot/{energy_plot_id}`;
        urlPath = urlPath.replace(`{${"energy_plot_id"}}`, encodeURIComponent(String(requestParameters['energyPlotId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get Energy Plot
     */
    async v2GetEnergyPlot(requestParameters, initOverrides) {
        const response = await this.v2GetEnergyPlotRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
